














































import IconBase from "@/common/components/atoms/IconBase.vue";
import IconCheckbox from "@/common/components/icons/IconCheckbox.vue";
import { is } from "vee-validate/dist/rules";
import Component from "vue-class-component";
import { Prop, Vue, Model } from "vue-property-decorator";

@Component({
  components: {
    IconBase,
    IconCheckbox
  }
})
export default class InputCheckBox extends Vue {
  model = {
    prop: "checked",
    event: "input"
  };

  @Prop({ type: String, required: true }) name!: string;
  @Prop() checked!: any;
  @Prop() value!: any;
  @Prop({ type: String, required: false, default: "main" }) kind!: string;
  @Prop({ type: String, required: false }) error!: string;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  updateValue(e: any) {
    const value = e.target.checked ? this.value : "";
    this.$emit("input", value);
    this.$emit("checked", value);
  }

  get ischecked() {
    return this.value;
  }
}
